/**
* @summary - Contract Create Form
* @author Yuvasri S
* @since 2024-11-29
*/
import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import CustomTextField from "../commoncomponents/CustomTextField";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import axios from "axios";
import { getAuthToken, getcompanyId, getFacilityId, getCreatedBy, getModifiedBy } from "../../utility/tokenUtility";
import { MasterGraph } from "../../utility/apiURLS";
import CustomDialog from "../commoncomponents/CustomDialog";
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Rating, Stack, Typography } from '@mui/material';
import PageTitle from "../commoncomponents/PageTitle";
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
import moment from 'moment/moment';
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomTextArea from '../commoncomponents/CustomTextArea';
import ContractManagementRepository from "../../api/repositories/contractManagementRepository";
import utils from "../../utility/utilities";
import { useLocation } from 'react-router-dom';
import { active, inActive, workTypeOptions } from '../../utility/message';
import { logDOM } from '@testing-library/react';


const ContractForm = forwardRef((props, ref) => {

    const location = useLocation();
    const isEditMode = location?.state?.editmode;
    const isViewMode = location?.state?.viewMode;
    const isCreateMode = location?.state?.createMode;
    const { onServiceChange, totalPPMRate } = props; // Add a prop for the callback

    const facilityId = getFacilityId('facilityId');

    const [serviceOptions, setServiceOptions] = useState([]);

    const [vendorNameOptions, setVendorNameOptions] = useState([]);

    const [contractTypeOptions, setContractTypeOptions] = useState([]);

    const [vendorStatusOptions, setVendorStatusOptions] = useState([]);
  
    const statusOptions = [active, inActive];

    const [formState, setFormState] = useState({
        service: '',
        contractNo: '',
        vendorName: '',
        vendorCode: '',
        contractType: '',
        vendorStatus: '',
        contractStartDate: '',
        contractEndDate: '',
        totalContractValue: totalPPMRate,
        workType: [],
        status: active,
        reason:'',
        isRenewal:false,
        telephoneNo: '',
        faxNo: '',
        email: '',
        address: '',
        remarks: '',
        rating: 0,
    });
    const [errors, setErrors] = useState({});
    const [disableContractNo, setDisableContractNo] = useState(false);
    const serviceType = formState.service.value === 'FEMS' ? 'fem' : 'bem';

    const currentDate = utils.getCurrentDateFormatted("DD-MM-YYYY");

    const [isDirty, setIsDirty] = useState(false); //unsaved changes
    const [reasonField,setReasonField] = useState(false);
    const [statusFieldDisable,setStatusFieldDisable] = useState(false);

    const handleNumericValue = (value) => {
        // Allow digits, +, and -
        const numericValue = value.replace(/[^0-9+-]/g, "");
        return numericValue.slice(0, 13); // Limit to a maximum length of 13 characters
    };

    const handleOnChange = (values, name, setChanges = false) => {
        let processedValue = values;
        let isObject = typeof values === 'object';
        let check = isObject == true ? values?.label != '' ? true : false : true;
        if ((!setChanges || name == "contractNo") && check) {
            setIsDirty(true);
        }
        // Special handling for numeric fields
        if (name === "telephoneNo" || name === "faxNo") {
            processedValue = handleNumericValue(values);
        }

        // Update form state
        setFormState((prev) => {
            const updatedState = { ...prev, [name]: processedValue };

            // Set vendorCode based on vendorName
            if (name === "vendorName") {
                updatedState.vendorCode = values?.value || "";
            }

            // Notify parent if the service value changes
            if (name === "service" && onServiceChange) {
                onServiceChange(processedValue);
            }

            
            if(name === "reason" || name === "status"){
               
                if(name === "status" && !(values?.id)){
                    setReasonField(true);
                    // setReasonErrorState(true);
                } else if (name === "status" && values?.id) {
                    updatedState.reason = "";
                    setReasonField(false);
                        
                }
            };
            setErrors((prev) => ({
                ...prev,
                reason: null, // Clear any existing error
            }));   

            return updatedState;
        });


        // Validation logic
        setErrors((prev) => {
            let errorMessage = null;

            // Email format validation
            if (name === "email" && processedValue) {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(processedValue)) {
                    errorMessage = "Invalid email format.";
                }
            }

            // Required field validation for other fields
            if (["service", "contractNo", "vendorName", "contractStartDate", "contractEndDate"].includes(name) && !processedValue) {
                errorMessage = `${name === "service"
                    ? "Service"
                    : name === "contractNo"
                        ? "Contract No."
                        : name === "contractStartDate"
                            ? "Contract Start Date"
                            : name === "contractEndDate"
                                ? "Contract End Date"
                                : "Vendor Name"
                    } is required.`;
            }

            return { ...prev, [name]: errorMessage };
        });
    };


    const handleWorkTypeChange = (event) => {

        const { value, checked } = event.target;
        setFormState((prev) => ({
            ...prev,
            workType: checked
                ? [...(prev.workType || []), value]
                : (prev.workType || []).filter((service) => service !== value),
        }));
    };

    const handleContractStartDate = (newDate) => {
        if (newDate) {
            let dayin = moment(newDate, 'DD/MM/YYYY', true);
            if (dayin.isValid()) {
                let formattedDate = dayin.format('YYYY-MM-DD HH:mm:ss');
                setFormState((prev) => ({
                    ...prev,
                    contractStartDate: formattedDate,
                }));
                setErrors((prev) => ({
                    ...prev,
                    contractStartDate: null, // Clear any existing error
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    contractStartDate: "Contract Start Date is required.",
                }));
            }
        } else {
            setErrors((prev) => ({
                ...prev,
                contractStartDate: "Contract Start Date is required.",
            }));
        }
    };

    const handleContractEndDate = (newDate) => {
        if (newDate) {
            let dayin = moment(newDate, 'DD/MM/YYYY', true);
            if (dayin.isValid()) {
                let formattedDate = dayin.format('YYYY-MM-DD HH:mm:ss');
                setFormState((prev) => ({
                    ...prev,
                    contractEndDate: formattedDate,
                }));
                setErrors((prev) => ({
                    ...prev,
                    contractEndDate: null, // Clear any existing error
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    contractEndDate: "Contract End Date is required.",
                }));
            }
        } else {
            setErrors((prev) => ({
                ...prev,
                contractEndDate: "Contract End Date is required.",
            }));
        }
    };


    const handleRatingChange = (e, newValue) => {
        setFormState((prev) => ({
            ...prev,
            rating: newValue,
        }));
    };


    const formatDateForDisplay = (date) => {
        return moment(date).format('DD/MM/YYYY');
    };

    const calculateMinimumDate = (date) => {
        return moment(date).add(1, 'days').format('DD/MM/YYYY');
    };

    const getVendorStatus = async () => {
        try {
          const vendorStatus = await ContractManagementRepository.fetchVendorStatus();
          setVendorStatusOptions(vendorStatus);
          return vendorStatus;
        } catch (error) {
          console.error("Error fetching vendor status:", error);
          return [];
        }
      };

    const getLov = async () => {
        try {
            const services = await ContractManagementRepository.fetchServiceOptions();
            setServiceOptions(services);
            // Set the default selection to the first option
            if (services.length > 0 && isCreateMode) {
                handleOnChange(services[1], "service", true);
            }
            const vendorName = await ContractManagementRepository.fetchVendorName();
            setVendorNameOptions(vendorName);
            const getLOVs = await ContractManagementRepository.getAllLovValues();
            const getContractypeOptions = getLOVs?.femcontracttypes?.map((item) => (
                                            {
                                                key: `option${item?.id}`,
                                                label: item?.contracttype || "",
                                                id: item?.id || "",
                                                value: item?.contracttype || ""
                                            }))
            setContractTypeOptions(getContractypeOptions || []);
            if (getContractypeOptions?.length > 0 && isCreateMode) {
                handleOnChange(getContractypeOptions[0], "contractType", true);
            };

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    

    const getContractData = async()=>{
        const getService = location?.state?.serviceDesc === "FEMS" ? "fem" : "bem"
        const getContractDetails = await ContractManagementRepository.getContractData(getService,location?.state?.id);
        const vendorStatusOptionsList = await getVendorStatus();
        const getvendorStatusOptions = vendorStatusOptionsList?.find((option)=>option?.id === getContractDetails?.[`${getService}vendorstatusId`]);

        setFormState((prev)=>({
            ...prev,
            address:getContractDetails?.address || "",
            contractEndDate:getContractDetails?.enddate || "",
            contractNo:getContractDetails?.contractno || "",
            contractStartDate:getContractDetails?.startdate || "",
            contractType:{id:getContractDetails?.[`${getService}contracttypeId`] || "",label:getContractDetails?.contracttype || "",value:getContractDetails?.contracttype || ""} || "",
            email:getContractDetails?.email || "",
            faxNo:getContractDetails?.faxno || "",
            rating:getContractDetails?.rating || "",
            remarks:getContractDetails?.remarks || "",
            service:{id:getContractDetails?.serviceid || "",label:getContractDetails?.serviceDesc || "",value:getContractDetails?.serviceDesc || ""} || "",
            status:{id:getContractDetails?.isactive || "",label:getContractDetails?.isactiveformate || "",value:getContractDetails?.isactiveformate || "",fieldID:(getContractDetails?.isactive ? active?.fieldID : inActive?.fieldID)} || "",
            reason:getContractDetails?.reason || "",
            telephoneNo:getContractDetails?.telephoneno || "",
            totalContractValue:getContractDetails?.totalcontractvalue || "",
            vendorCode:getContractDetails?.vendorcode || "",
            vendorName:{id:getContractDetails?.vendorid || "", label:getContractDetails?.vendorname || "", value:getContractDetails?.vendorname || ""} || "",
            vendorStatus:getvendorStatusOptions || "",
            workType: getContractDetails?.worktype ? getContractDetails?.worktype.split(",") : [],
        }));

        if(!getContractDetails?.isactive){                        
            setReasonField(true);
            setStatusFieldDisable(true);
        };
    };

    useEffect(() => {
        getVendorStatus();
        getLov();
        if(!isCreateMode){
            getContractData();
        }
    }, []);


    const validateFields = async () => {
        const requiredFields = ['service', 'contractNo', 'vendorName', 'contractStartDate', 'contractEndDate'];
        const newErrors = {};

        // Validate required fields
        requiredFields.forEach((field) => {            
            if (
                !formState[field] ||
                (field === 'vendorName' && !formState[field].label) // Specific check for vendorName
            ) {
                newErrors[field] = `${field === 'service'
                    ? 'Service'
                    : field === 'contractNo'
                        ? 'Contract No.'
                        : field === 'vendorName'
                            ? 'Vendor Name'
                            : field === 'contractStartDate'
                                ? 'Contract Start Date'
                                : field === 'contractEndDate'
                                    ? 'Contract End Date'
                                    : ''
                    } is required.`;
            }
        });

        // Additional check for date validity (if required)
        const contractStartDate = moment(formState.contractStartDate, true);
        const contractEndDate = moment(formState.contractEndDate, true);

        if (!contractStartDate.isValid()) {
            newErrors.contractStartDate = 'Contract Start Date is required.';
        }

        if (!contractEndDate.isValid()) {
            newErrors.contractEndDate = 'Contract End Date is required.';
        }


        if (contractStartDate.isValid() && contractEndDate.isValid() && contractEndDate.isSameOrBefore(contractStartDate)) {
            newErrors.contractEndDate = 'Contract End Date must be after Contract Start Date.';
        }        
        // Validate reason field if required
        if (reasonField && !(formState?.reason)) {                                 
            newErrors.reason = 'Reason is required.';
        }

        // Set errors and return validation result
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        

        setErrors({}); // Clear errors if validation passes
        return true; // Validation passed
    };

    const handleSubmit = async () => {
        
        let response;
        const requiredFields = ['service', 'contractNo', 'vendorName', 'contractStartDate', 'contractEndDate'];
        const newErrors = {};

        // Validate required fields
        requiredFields.forEach((field) => {
            
            if (
                !formState[field] ||
                (field === 'vendorName' && !formState[field].label) // Specific check for vendorName
            ) {
                newErrors[field] = `${field === 'service'
                    ? 'Service'
                    : field === 'contractNo'
                        ? 'Contract No.'
                        : field === 'vendorName'
                            ? 'Vendor Name'
                            : field === 'contractStartDate'
                                ? 'Contract Start Date'
                                : field === 'contractEndDate'
                                    ? 'Contract End Date'
                                    : ''
                    } is required.`;
            }
        });

        // Additional check for date validity (if required)
        // const contractStartDate = moment(formState.contractStartDate, 'YYYY-MM-DD HH:mm:ss', true);
        // const contractEndDate = moment(formState.contractEndDate, 'YYYY-MM-DD HH:mm:ss', true);
        const contractStartDate = moment(formState.contractStartDate, true);
        const contractEndDate = moment(formState.contractEndDate, true);

        if (!contractStartDate.isValid()) {
            newErrors.contractStartDate = 'Contract Start Date is required.';
        }

        if (!contractEndDate.isValid()) {
            newErrors.contractEndDate = 'Contract End Date is required.';
        }

        if (contractStartDate.isValid() && contractEndDate.isValid() && contractEndDate.isSameOrBefore(contractStartDate)) {
            newErrors.contractEndDate = 'Contract End Date must be after Contract Start Date.';
        }

        // Validate contractNo for only spaces
        if (formState.contractNo && formState.contractNo.trim() === '') {
            newErrors.contractNo = 'Contract No. cannot contain only spaces';
        }

        // Validate reason field if required
        if (reasonField && !(formState?.reason)) {            
            newErrors.reason = 'Reason is required.';
        }

        if (Object.keys(newErrors).length > 0) {
            
            setErrors(newErrors);
            return;
        }
                
        const serviceType = formState?.service?.value === 'FEMS' ? 'fem' : 'bem';
        const contractID = location?.state?.id;
        const api_Payload = {
            facilityId: facilityId || "",
            contractno: formState?.contractNo || "",
            vendorid: formState?.vendorName?.id || "",
            serviceid: formState?.service?.id || "",
            startdate: formState?.contractStartDate || "",
            enddate: formState?.contractEndDate || "",
            vendorname: formState?.vendorName?.label || "",
            worktype: formState?.workType && formState?.workType?.length > 0 ? formState?.workType?.join(',') : '',
            totalcontractvalue: formState.totalContractValue || 0.00,
            address: formState?.address  || "",
            telephoneno: formState?.telephoneNo || "",
            faxno: formState?.faxNo || "",
            email: formState?.email || "",
            remarks: formState?.remarks || "",
            rating: formState?.rating || "",
            [`${serviceType}contractstatusId`]: formState?.status?.fieldID || "",
            isactive: formState?.status?.id || "",
            inactivereason:formState?.reason || "",
            [`${serviceType}contracttypeId`]: formState?.contractType?.id || "",
            [`${serviceType}vendorstatusId`]: formState?.vendorStatus?.id || "",
            isrenewal:isEditMode ? location?.state?.isrenewal : false,
            id:contractID || ""
        };
        
        // API call to create contract management
        if(location?.state?.id){            
            response = await ContractManagementRepository.updateContractManagement(serviceType,api_Payload);
        } else {
            response = await ContractManagementRepository.createContractManagement(serviceType, api_Payload);
        }
        if(response?.id){            
            setDisableContractNo(true);
            setStatusFieldDisable(true);
        };
        setIsDirty(false);
        return response;
    };


    // Expose handleSubmit to the parent via ref
    useImperativeHandle(ref, () => ({
        handleSubmit,
        serviceType,
        validateFields,
        hasUnsavedChanges: () => isDirty,
    }));

    useEffect(() => {
        if (props.onServiceChange) {
            props.onServiceChange(formState.service);
        }
    }, [formState.service]);

    useEffect(() => {
        // Update the totalContractValue when totalPPMRate changes
        setFormState((prevState) => ({
            ...prevState,
            totalContractValue: totalPPMRate,
        }));
    }, [totalPPMRate]);

    
    return (
        <>
            <PageTitle
                title={location?.state?.title}
            />

            <DefaultCard sx={{ height: "100%" }}>
                <form onSubmit={handleSubmit} style={{ position: "relative" }}>
                    <Box mb={2}>
                        <Grid container gap={3}>
                            <Grid item xs={6} md={3.8}>
                                <CustomSelectInput
                                    disableClearable={true}
                                    label="Service"
                                    isMandatoryField={true}
                                    value={formState.service}
                                    onChange={(value) => handleOnChange(value, "service")}
                                    options={serviceOptions}
                                    id="service"
                                    name="service"
                                    error={!!errors.service}
                                    errorMessage={errors.service}
                                    disabled={isViewMode || isEditMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    disableClearable={true}
                                    label="Contract No."
                                    isMandatoryField={true}
                                    value={formState.contractNo}
                                    onChange={handleOnChange}
                                    id="contractNo"
                                    name="contractNo"
                                    error={!!errors.contractNo}
                                    errorMessage={errors.contractNo}
                                    disabled={location?.state?.id || isViewMode || disableContractNo}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextFieldWithSearch
                                    label="Vendor Name"
                                    id="vendorName"
                                    name="vendorName"
                                    value={formState.vendorName}
                                    options={vendorNameOptions.map(option => ({
                                        label: option.label,
                                        value: option.value,
                                        id: option.id
                                    }))}
                                    onChange={handleOnChange}
                                    isMandatoryField={true}
                                    error={!!errors.vendorName}
                                    errorMessage={errors.vendorName}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    label="Vendor Code"
                                    placeholder={""}
                                    id="vendorCode"
                                    name="vendorCode"
                                    disabled
                                    value={formState.vendorCode}
                                    isRefilByOtherField={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomSelectInput
                                    disableClearable={true}
                                    label="Contract Type"
                                    value={formState.contractType}
                                    onChange={handleOnChange}
                                    options={contractTypeOptions}
                                    id="contractType"
                                    name="contractType"
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomSelectInput
                                    disableClearable={true}
                                    label="Vendor Status"
                                    value={formState.vendorStatus}
                                    onChange={handleOnChange}
                                    options={vendorStatusOptions}
                                    id="vendorStatus"
                                    name="vendorStatus"
                                    disabled={isViewMode}

                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomDatePicker
                                    label="Contract Start Date"
                                    id="contractStartDate"
                                    name="contractStartDate"
                                    value={formatDateForDisplay(formState.contractStartDate)}
                                    onDateChange={handleContractStartDate}
                                    isMandatoryField={true}
                                   // minimumDate={currentDate}
                                   // maxDate={currentDate}
                                    error={!!errors.contractStartDate}
                                    errorMessage={errors.contractStartDate}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomDatePicker
                                    label="Contract End Date"
                                    id="contract-end-date"
                                    name="contractEndDate"
                                    value={formatDateForDisplay(formState.contractEndDate)}
                                    onDateChange={handleContractEndDate}
                                    minimumDate={calculateMinimumDate(formState.contractStartDate)}
                                   // maxDate={new Date()}
                                    isMandatoryField={true}
                                    error={!!errors.contractEndDate}
                                    errorMessage={errors.contractEndDate}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    label="Total Contract Value"
                                    placeholder={""}
                                    id="totalContractValue"
                                    name="totalContractValue"
                                    disabled
                                    value={formState.totalContractValue}
                                    isRefilByOtherField={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <FormControl fullWidth error={true}>
                                    <Box>
                                        <Typography variant="labelSm">Work Type</Typography>
                                    </Box>
                                    <FormGroup row sx={{ justifyContent: "space-between" }}>
                                        {workTypeOptions.map((wt) => (
                                            <FormControlLabel
                                                key={wt.value}
                                                control={
                                                    <Checkbox
                                                        checked={formState.workType.includes(wt.value)}
                                                        onChange={handleWorkTypeChange}
                                                        value={wt.value}
                                                        disabled={isViewMode}
                                                    />
                                                }
                                                label={wt.label}
                                            />
                                        ))}
                                    </FormGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomSelectInput
                                    disableClearable={true}
                                    label= {isEditMode ? "Status (Note: To Terminate, select 'Inactive')" : "Status" }
                                    value={formState.status}
                                    onChange={handleOnChange}
                                    options={statusOptions}
                                    id="status"
                                    name="status"
                                    disabled={ isCreateMode || isViewMode || statusFieldDisable}
                                />
                            </Grid>
                            {reasonField && (<Grid item xs={6} md={3.8}>
                                <CustomTextArea
                                    label="Reason"
                                    id="reason"
                                    name="reason"
                                    value={formState?.reason || ""}
                                    onChange={(e) => handleOnChange(e, "reason")}
                                    maxlength={250}
                                    error={!!errors?.reason}
                                    helperText={errors?.reason || ""}
                                    isMandatoryField={reasonField}
                                    disabled={isViewMode || statusFieldDisable}
                                />
                            </Grid>)}

                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    label="Telephone No."
                                    placeholder={""}
                                    id="telephoneNo"
                                    name="telephoneNo"
                                    onChange={handleOnChange}
                                    value={formState.telephoneNo}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    label="Fax No."
                                    placeholder={""}
                                    id="faxNo"
                                    name="faxNo"
                                    onChange={handleOnChange}
                                    value={formState.faxNo}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextField
                                    label="Email"
                                    placeholder={""}
                                    id="email"
                                    name="email"
                                    onChange={handleOnChange}
                                    value={formState.email}
                                    error={!!errors.email}
                                    errorMessage={errors.email}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextArea
                                    label="Address"
                                    id="address"
                                    name="address"
                                    value={formState.address}
                                    onChange={(e) => handleOnChange(e, "address")}
                                    maxlength={180}
                                    disabled={isViewMode}
                                />
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <FormLabel component="legend">Rating</FormLabel>
                                <Stack spacing={6}>
                                    <Rating
                                        name="rating"
                                        value={formState.rating}
                                        onChange={handleRatingChange}
                                        size="large"
                                        sx={{
                                            fontSize: '3rem',
                                            '& .MuiRating-icon': {
                                                marginRight: '2rem',
                                            },
                                        }}
                                        disabled={isViewMode}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} md={3.8}>
                                <CustomTextArea
                                    label="Remarks"
                                    id="remarks"
                                    name="remarks"
                                    value={formState.remarks}
                                    onChange={(e) => handleOnChange(e, "remarks")}
                                    maxlength={180}
                                    disabled={isViewMode}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </form>
            </DefaultCard>
        </>
    )
});

export default ContractForm;